import { DefaultSet } from './default'

export class User extends DefaultSet {
    name: string
    given_name: string
    family_name: string
    nickname?: string
    mail: string

    user_id: string
    role: string
    role_name: string

    region: string
    brand_region: { region: string; retail_brand: string }[]
    business_function: string
    store: Store
    application_profiles?: any[]

    language?: string
    profilePicURL?: string

    dictionary?: any

    phase2_enabled?: boolean

    constructor(data?: any) {
        super()

        if (data) {
            this._set(data)
        }
    }
}

export class ProfileData {
    attachment?: {
        _id: string
        ext: string
        name: string
        url: string
    }
    profilePictureId?: string
    language?: string
    nickname?: string
    notificationVisibility?: any
    moduleSettings?: any
    editProfile?: {
        authorEdit: {
            userId: string
            name: string
            lastName: string
            nickname?: string
        }
        editDate: number
        profileNameToReference: string
        profileIdToReference: string
    }
    user: any
    isAdminSocialHub: boolean
    constructor() {
        this.language = 'en'
    }
}

export interface Store {
    store_id: string
    macroregion: string
    banner: string
    region: string
    country: string
}
